import { loginOrRegisterMapping } from "@/api/authApi";
import { getCurrentUserId } from "@/core/auth/token";

const LOGIN_FLAG_PREFIX = "ifLoginOPEN_";

function getLoginFlagKey(userId) {
  return `${LOGIN_FLAG_PREFIX}${userId}`;
}

export function resetLoginSyncFlag(userId) {
  if (userId == null) {
    return;
  }
  window.sessionStorage.removeItem(getLoginFlagKey(userId));
}

export async function synchronizeUserPermission(store) {
  const userId = getCurrentUserId();
  if (userId != null) {
    const flagKey = getLoginFlagKey(userId);
    if (window.sessionStorage.getItem(flagKey) === "true") {
      return;
    }
  }

  const res = await loginOrRegisterMapping();
  if (res?.code === 0) {
    if (userId != null) {
      window.sessionStorage.setItem(getLoginFlagKey(userId), "true");
    }
    if (store && res.data) {
      store.commit("auth/setAuth", {
        localUser: res.data.user,
        isAdmin: res.data.isAdmin,
      });
      store.commit("auth/setLoginReady", true);
    }
  }
}
